import React from 'react';
import { styled, experimental_sx as sx } from '@mui/system';
import { Swiper as SwiperSlider, SwiperSlide } from 'swiper/react';
import { Pagination, EffectFade, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';

interface Props {
   imageUrls: string[];
   captions?: string[];
}

const Swiper = styled(SwiperSlider)(
   sx({
      width: '100%',
      overflow: 'hidden'
   })
);

const Slide = styled(SwiperSlide)(
   sx({
      borderRadius: {
         md: '6px'
      },
      position: 'relative',
      pb: '33.333%',
      overflow: 'hidden',

      '& img': {
         position: 'absolute',
         top: 0,
         left: 0,
         width: '100%',
         height: '100%',
         objectFit: 'cover',
      }
   })
);

const Caption = styled('div')(
   sx({
      position: 'absolute',
      right: 0,
      bottom: 0,
      left: 0,
      zIndex: 2,
      px: {
         xs: 2,
         md: 3
      },
      pt: 6,
      pb: 2,
      background: 'linear-gradient(0deg, rgba(15, 23, 42, .78), rgba(15, 23, 42, 0))',
      color: '#fff',
      fontSize: {
         xs: 13,
         md: 15
      },
      fontWeight: 700,
      lineHeight: 1.35,
      textShadow: '0 1px 2px rgba(15, 23, 42, .45)'
   })
);

export default function HomeSlider(props: Props) {
   const { imageUrls, captions = [] } = props;

   return (
      <Swiper
         pagination={imageUrls.length > 1 ? {clickable: true} : false}
         modules={[Pagination, EffectFade, Autoplay]}
         autoplay={imageUrls.length > 1 ? {
            delay: 2500,
            disableOnInteraction: false,
         } : false}
         sx={{ pb: imageUrls.length === 1 ? '0' : '40px'}}
         effect={'fade'}
         loop={imageUrls.length > 1}
      >
         {imageUrls.map((url, index) => {
            const caption = captions[index] || '';
            return (
               <Slide key={`${url}_${index}`}>
                  <img src={url} alt={caption || 'Gallery photo'} />
                  {caption && <Caption>{caption}</Caption>}
               </Slide>
            );
         })}
      </Swiper>
   );
};
